import ConfigurationDetailsActions from '../app/configurationDetails/components/ConfigurationDetailsActions';
import { GoToConfiguratorActionState } from '../app/configurationDetails/components/GoToConfiguratorActionState';
import ConfiguratorActions from '../app/configurator/components/ConfiguratorActions';
import { RequestQuoteActionState } from '../app/configurator/components/RequestQuoteAction/RequestQuoteActionState';
import ModularConfigurationPurchaseActions from '../app/modularConfigurator/components/ModularConfiguratorCoordinator/ModularConfigurator/ModularConfiguratorSummary/ModularConfigurationPurchaseActions/ModularConfigurationPurchaseActions';
import {
  ConfigurationDetailsContext,
  ConfiguratorSummaryContext,
  ModularConfiguratorSummaryContext,
} from '../app/shared/regions/RegionDataContext';
import { RegionManager } from '../app/shared/regions/RegionManager';

export default function (regionManager: RegionManager) {
  regionManager.registerViewWithRegion(
    'ConfiguratorSummary',
    (data: ConfiguratorSummaryContext['data'], appState) => {
      return {
        configurator: data.configurator,
        store: data.store,
        translation: appState.translation.configurationPage,
        requestQuoteLinkTranslation: appState.translation.requestQuoteLink,
      };
    },
    ConfiguratorActions,
  );
  regionManager.registerViewWithRegion(
    'ModularConfiguratorSummary',
    (data: ModularConfiguratorSummaryContext['data']) => {
      return data;
    },
    ModularConfigurationPurchaseActions,
  );
  regionManager.registerViewWithRegion(
    'ConfigurationDetails',
    (data: ConfigurationDetailsContext['data'], appState) => {
      return {
        code: data.code,
        details: data.details,
        store: appState.store,
        requestQuote: new RequestQuoteActionState(appState.navigation, data.code),
        translation: {
          requestQuoteButton: appState.translation.configurationPage.summary.requestQuoteButton,
          configureButton:
            appState.translation.productFamilyPage.modelsSection.productInfo.actions.configureChairButton,
        },
        configure: new GoToConfiguratorActionState(appState.navigation, data.code, data.details.configuration),
      };
    },
    ConfigurationDetailsActions,
  );
}
